module.exports = __webpack_public_path__ + "img/avatar2.3f42f06f.png";